import { useModalStore } from '@/stores';
import { Button } from '@/components/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import styles from './InfoModal.module.css';

interface InfoModalProps {
  title: string;
  message: string;
}

export function InfoModal({ title, message }: InfoModalProps) {
  const { closeModal } = useModalStore();

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faInfoCircle} className={styles.icon} />
      </div>

      <h3 className={styles.title}>{title}</h3>

      <p className={styles.message}>{message}</p>

      <div className={styles.actions}>
        <Button variant="primary" onClick={closeModal}>
          Understood
        </Button>
      </div>
    </div>
  );
}
